var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recharge-header"},[_c('img',{attrs:{"src":_vm.userInfo.pic,"alt":""}}),_c('span',[_vm._v("ID: "+_vm._s(_vm.userInfo.userId))])])
}
var staticRenderFns = []

export { render, staticRenderFns }